export default __webpack_public_path__ + "static/media/bpi-wealth.e561a3e1.png";